import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { Indicator as BaseIndicator } from '@ubisend/pulse-components';

const FatIndicator = styled(BaseIndicator)`
  ${tw`w-3 h-3 mr-2`}
`;

// State constants for better maintainability
const STATES = {
  SUCCESS: 'Success',
  FAIL: 'Fail',
  PARTIAL_SUCCESS: 'Partial Success',
  PENDING: 'Pending'
};

// Color mapping for different states
const getStateColor = (state) => {
  switch (state) {
    case STATES.SUCCESS:
      return 'positive';
    case STATES.FAIL:
    case STATES.PARTIAL_SUCCESS:
      return 'danger';
    case STATES.PENDING:
    default:
      return 'warning';
  }
};

const StateIndicator = ({ state }) => (
  <FatIndicator colour={getStateColor(state)} />
);

StateIndicator.propTypes = {
  state: PropTypes.string.isRequired
};

const levels = {
  [STATES.SUCCESS]: () => <StateIndicator state={STATES.SUCCESS} />,
  [STATES.FAIL]: () => <StateIndicator state={STATES.FAIL} />,
  [STATES.PARTIAL_SUCCESS]: () => <StateIndicator state={STATES.PARTIAL_SUCCESS} />,
  [STATES.PENDING]: () => <StateIndicator state={STATES.PENDING} />
};

const StateLevel = ({ level }) => {
  const Indicator = levels[level] || levels[STATES.PENDING];
  return <Indicator />;
};

StateLevel.propTypes = {
  level: PropTypes.string.isRequired
};

export default StateLevel;
